import { render, staticRenderFns } from "./MarketNorm.vue?vue&type=template&id=69d1b447&"
import script from "./MarketNorm.vue?vue&type=script&lang=js&"
export * from "./MarketNorm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports